<nz-result nzStatus="500" nzTitle="Sin Conexión" nzSubTitle="Lo sentimos, estamos experimentando fallas en la conexión con los servicios, verifica tu conexión a internet">
    <div nz-result-extra>
      <button nz-button (click)="retry()" nzType="primary">Reintentar</button>
    </div>
  </nz-result>